import { useState } from "react";

export default function EventGallery({ images }) {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <>
      {images && images.length > 0 && (
        <div className="mt-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Gallery</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {images.map((img, idx) => (
              <div
                key={idx}
                className="relative overflow-hidden rounded-3xl shadow-lg group cursor-pointer"
                onClick={() => setSelectedImg(img)}
              >
                <img
                  src={img}
                  alt={`Gallery image ${idx + 1}`}
                  className="w-full h-48 object-cover transition-transform duration-300 ease-in-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-opacity-0 group-hover:bg-opacity-20 transition duration-300 rounded-3xl" />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Modal */}
      {selectedImg && (
        <div
          className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
          onClick={() => setSelectedImg(null)}
        >
          <img
            src={selectedImg}
            alt="Selected"
            className="max-h-[90%] max-w-[90%] rounded-3xl shadow-2xl"
            onClick={(e) => e.stopPropagation()} // evita cerrar al click en la imagen
          />
          <button
            className="absolute top-5 right-5 text-white text-3xl font-bold"
            onClick={() => setSelectedImg(null)}
          >
            &times;
          </button>
        </div>
      )}
    </>
  );
}
